import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

const NEON_CYAN = "#00f2ff";
const BG = "#020b14";
const CARD = "#051626";
const CARD_2 = "#031220";
const BORDER = "#1a2b3c";
const TEXT = "#ffffff";
const SUBTEXT = "#7f93a8";
const GREEN = "#00ff99";
const RED = "#ff4d6d";
const GOLD = "#ffd166";

function AdminWithdrawalsWebPage() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoadingId, setActionLoadingId] = useState(null);
  const [rejectItem, setRejectItem] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectNote, setRejectNote] = useState("");

  const loadWithdrawals = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API}/admin/withdrawals`);
      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Erreur chargement retraits");
      }

      setWithdrawals(Array.isArray(data.withdrawals) ? data.withdrawals : []);
    } catch (err) {
      console.log(err);
      alert("Impossible de charger les demandes de retrait.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWithdrawals();
  }, []);

  const formatDate = (value) => {
    if (!value) return "-";

    try {
      return new Date(value).toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    } catch (err) {
      return "-";
    }
  };

  const formatCoins = (value) => {
    return Number(value || 0).toLocaleString("fr-FR");
  };

  const formatEuros = (value) => {
    return Number(value || 0).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const getStatusStyle = (status) => {
    if (status === "approved") {
      return {
        color: GREEN,
        borderColor: "rgba(0,255,153,0.35)",
        background: "rgba(0,255,153,0.08)"
      };
    }

    if (status === "rejected") {
      return {
        color: RED,
        borderColor: "rgba(255,77,109,0.35)",
        background: "rgba(255,77,109,0.08)"
      };
    }

    return {
      color: GOLD,
      borderColor: "rgba(255,209,102,0.35)",
      background: "rgba(255,209,102,0.08)"
    };
  };

  const approveWithdrawal = async (item) => {
    const ok = window.confirm(
      `Confirmer que le paiement PayPal de ${formatEuros(item.amount_euros)} € a bien été envoyé à :\n\n${item.paypal_email}`
    );

    if (!ok) return;

    try {
      setActionLoadingId(item.id);

      const res = await fetch(`${API}/admin/withdrawals/${item.id}/approve`, {
        method: "PUT"
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Erreur validation retrait");
      }

      alert("Retrait approuvé.");
      loadWithdrawals();
    } catch (err) {
      console.log(err);
      alert("Impossible d'approuver ce retrait.");
    } finally {
      setActionLoadingId(null);
    }
  };

  const rejectWithdrawal = async () => {
    if (!rejectItem || !rejectReason) {
      alert("Choisis un motif de refus.");
      return;
    }

    try {
      setActionLoadingId(rejectItem.id);

      const res = await fetch(
        `${API}/admin/withdrawals/${rejectItem.id}/reject`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            reason: rejectReason,
            admin_note: rejectNote.trim() || null
          })
        }
      );

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Erreur refus retrait");
      }

      if (data.rejection_action === "convert_to_coins") {
        alert(
          `Retrait refusé. ${formatCoins(data.coins_returned)} Coins utilisables ont été recrédités au créateur.`
        );
      } else if (data.rejection_action === "refund_euros") {
        alert(
          `Retrait refusé. ${formatEuros(data.euros_refunded)} € ont été recrédités dans les revenus du créateur.`
        );
      } else {
        alert("Retrait refusé.");
      }

      setRejectItem(null);
      setRejectReason("");
      setRejectNote("");

      loadWithdrawals();
    } catch (err) {
      console.log(err);
      alert("Impossible de refuser ce retrait.");
    } finally {
      setActionLoadingId(null);
    }
  };

  const pendingCount = withdrawals.filter((item) => item.status === "pending").length;
  const approvedCount = withdrawals.filter((item) => item.status === "approved").length;
  const rejectedCount = withdrawals.filter((item) => item.status === "rejected").length;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: BG,
        color: TEXT
      }}
    >
      <div
        style={{
          height: 90,
          paddingTop: 35,
          paddingLeft: 15,
          paddingRight: 15,
          background: CARD_2,
          borderBottom: `1px solid ${BORDER}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            width: 50,
            background: "transparent",
            border: "none",
            color: NEON_CYAN,
            fontSize: 30,
            cursor: "pointer"
          }}
        >
          ‹
        </button>

        <div
          style={{
            color: TEXT,
            fontSize: 15,
            fontWeight: "900",
            letterSpacing: 1,
            textAlign: "center"
          }}
        >
          RETRAITS CREATEURS
        </div>

        <button
          onClick={loadWithdrawals}
          style={{
            width: 50,
            background: "transparent",
            border: "none",
            color: NEON_CYAN,
            fontSize: 18,
            cursor: "pointer",
            fontWeight: "900"
          }}
        >
          ↻
        </button>
      </div>

      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: 14,
          paddingBottom: 120
        }}
      >
        <div style={heroCard}>
          <div style={heroTitle}>💶 Demandes de retrait PayPal</div>

          <div style={heroDesc}>
            Les demandes affichées ici doivent être payées manuellement depuis le compte PayPal Business EVO LIVE.
            Après paiement réel, clique sur “Paiement effectué”.
          </div>
        </div>

        <div style={statsGrid}>
          <div style={statCard}>
            <div style={statLabel}>En attente</div>
            <div style={{ ...statValue, color: GOLD }}>{pendingCount}</div>
          </div>

          <div style={statCard}>
            <div style={statLabel}>Approuvés</div>
            <div style={{ ...statValue, color: GREEN }}>{approvedCount}</div>
          </div>

          <div style={statCard}>
            <div style={statLabel}>Refusés</div>
            <div style={{ ...statValue, color: RED }}>{rejectedCount}</div>
          </div>
        </div>

        {loading ? (
          <div style={emptyCard}>
            <div style={emptyTitle}>Chargement...</div>
            <div style={emptyText}>Récupération des demandes de retrait.</div>
          </div>
        ) : withdrawals.length === 0 ? (
          <div style={emptyCard}>
            <div style={emptyTitle}>Aucune demande</div>
            <div style={emptyText}>
              Les retraits demandés depuis l'application apparaîtront ici.
            </div>
          </div>
        ) : (
          <div>
            {withdrawals.map((item) => {
              const statusStyle = getStatusStyle(item.status);
              const disabled = item.status !== "pending" || actionLoadingId === item.id;

              return (
                <div key={item.id} style={withdrawalCard}>
                  <div style={cardTop}>
                    <div>
                      <div style={cardTitle}>
                        Demande #{item.id}
                      </div>

                      <div style={cardSub}>
                        {item.user_email || "Utilisateur inconnu"}
                      </div>
                    </div>

                    <div style={{ ...statusBadge, ...statusStyle }}>
                      {item.status || "pending"}
                    </div>
                  </div>

                  <div style={infoGrid}>
                    <InfoLine label="Montant" value={`${formatEuros(item.amount_euros)} €`} highlight />
                    <InfoLine label="Coins" value={`${formatCoins(item.coins_converted)} coins`} />
                    <InfoLine label="Méthode" value={item.payout_method || "paypal"} />
                    <InfoLine label="PayPal créateur" value={item.paypal_email || "Non fourni"} />
                    <InfoLine label="Date" value={formatDate(item.requested_at)} />
                  </div>

                  {item.status === "pending" && (
                    <div style={actionBox}>
                      <div style={warningText}>
                        1. Ouvre PayPal Business EVO LIVE. 2. Envoie {formatEuros(item.amount_euros)} € à {item.paypal_email || "l'adresse PayPal du créateur"}. 3. Clique sur “Paiement effectué”.
                      </div>

                      <div style={buttonsRow}>
                        <button
                          disabled={disabled}
                          onClick={() => approveWithdrawal(item)}
                          style={{
                            ...approveBtn,
                            opacity: disabled ? 0.55 : 1
                          }}
                        >
                          {actionLoadingId === item.id ? "Traitement..." : "✅ Paiement effectué"}
                        </button>

                        <button
                          disabled={disabled}
                          onClick={() => {
                            setRejectItem(item);
                            setRejectReason("");
                            setRejectNote("");
                          }}
                          style={{
                            ...rejectBtn,
                            opacity: disabled ? 0.55 : 1
                          }}
                        >
                          ❌ Refuser
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {rejectItem && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              background: "rgba(0,0,0,0.82)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: 560,
                maxHeight: "90vh",
                overflowY: "auto",
                background: CARD,
                border: `1px solid rgba(255,77,109,0.45)`,
                borderRadius: 18,
                padding: 18,
                boxShadow: "0 18px 60px rgba(0,0,0,0.65)"
              }}
            >
              <div
                style={{
                  color: TEXT,
                  fontSize: 20,
                  fontWeight: "900",
                  marginBottom: 6
                }}
              >
                Refuser le retrait #{rejectItem.id}
              </div>

              <div
                style={{
                  color: SUBTEXT,
                  fontSize: 13,
                  lineHeight: "20px",
                  marginBottom: 16
                }}
              >
                Montant : {formatEuros(rejectItem.amount_euros)} €. Choisis le motif réel du refus.
                L'action financière dépend du motif sélectionné.
              </div>

              {[
                {
                  value: "minor",
                  title: "Utilisateur mineur",
                  desc: "Le retrait est refusé et le montant devient des Coins utilisables."
                },
                {
                  value: "identity_not_verified",
                  title: "Identité non vérifiée",
                  desc: "Le retrait est refusé et le montant devient des Coins utilisables."
                },
                {
                  value: "identity_rejected",
                  title: "Identité refusée",
                  desc: "Le retrait est refusé et le montant devient des Coins utilisables."
                },
                {
                  value: "admin_error",
                  title: "Erreur EVO / admin",
                  desc: "Le retrait est annulé et le montant est recrédité en euros au créateur."
                }
              ].map((reason) => {
                const selected = rejectReason === reason.value;

                return (
                  <button
                    key={reason.value}
                    type="button"
                    onClick={() => setRejectReason(reason.value)}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      background: selected
                        ? "rgba(255,77,109,0.12)"
                        : "#071a2a",
                      border: selected
                        ? `1px solid ${RED}`
                        : `1px solid ${BORDER}`,
                      borderRadius: 12,
                      padding: 13,
                      marginBottom: 9,
                      cursor: "pointer"
                    }}
                  >
                    <div
                      style={{
                        color: selected ? RED : TEXT,
                        fontSize: 14,
                        fontWeight: "900"
                      }}
                    >
                      {selected ? "● " : "○ "}
                      {reason.title}
                    </div>

                    <div
                      style={{
                        color: SUBTEXT,
                        fontSize: 12,
                        lineHeight: "18px",
                        marginTop: 5
                      }}
                    >
                      {reason.desc}
                    </div>
                  </button>
                );
              })}

              <textarea
                value={rejectNote}
                onChange={(e) => setRejectNote(e.target.value)}
                placeholder="Note admin facultative..."
                maxLength={500}
                style={{
                  width: "100%",
                  minHeight: 85,
                  boxSizing: "border-box",
                  marginTop: 6,
                  background: "#020b14",
                  border: `1px solid ${BORDER}`,
                  borderRadius: 12,
                  color: TEXT,
                  padding: 12,
                  resize: "vertical",
                  outline: "none"
                }}
              />

              {rejectReason && (
                <div
                  style={{
                    color:
                      rejectReason === "admin_error"
                        ? GOLD
                        : NEON_CYAN,
                    background: "#071a2a",
                    border: `1px solid ${BORDER}`,
                    borderRadius: 12,
                    padding: 11,
                    marginTop: 12,
                    fontSize: 12,
                    lineHeight: "18px",
                    fontWeight: "800"
                  }}
                >
                  {rejectReason === "admin_error"
                    ? `Résultat : ${formatEuros(rejectItem.amount_euros)} € seront recrédités dans les revenus créateur.`
                    : `Résultat : ${formatCoins(
                        Math.round(Number(rejectItem.amount_euros || 0) * 100)
                      )} Coins utilisables seront recrédités.`}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  gap: 10,
                  marginTop: 16,
                  flexWrap: "wrap"
                }}
              >
                <button
                  type="button"
                  onClick={() => {
                    setRejectItem(null);
                    setRejectReason("");
                    setRejectNote("");
                  }}
                  disabled={actionLoadingId === rejectItem.id}
                  style={{
                    flex: 1,
                    minWidth: 140,
                    background: "transparent",
                    color: TEXT,
                    border: `1px solid ${BORDER}`,
                    borderRadius: 12,
                    padding: "12px 14px",
                    cursor: "pointer",
                    fontWeight: "900"
                  }}
                >
                  Annuler
                </button>

                <button
                  type="button"
                  onClick={rejectWithdrawal}
                  disabled={
                    !rejectReason ||
                    actionLoadingId === rejectItem.id
                  }
                  style={{
                    flex: 1,
                    minWidth: 190,
                    background: rejectReason
                      ? RED
                      : "rgba(255,77,109,0.25)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 12,
                    padding: "12px 14px",
                    cursor: rejectReason ? "pointer" : "not-allowed",
                    fontWeight: "900"
                  }}
                >
                  {actionLoadingId === rejectItem.id
                    ? "Traitement..."
                    : "Confirmer le refus"}
                </button>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={backBtn}
        >
          Retour panneau admin
        </button>
      </div>
    </div>
  );
}

function InfoLine({ label, value, highlight }) {
  return (
    <div style={infoLine}>
      <div style={infoLabel}>{label}</div>
      <div style={{ ...infoValue, color: highlight ? NEON_CYAN : TEXT }}>
        {value}
      </div>
    </div>
  );
}

const heroCard = {
  background: CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: 14,
  padding: 15,
  marginBottom: 14
};

const heroTitle = {
  color: TEXT,
  fontSize: 18,
  fontWeight: "900",
  marginBottom: 6
};

const heroDesc = {
  color: SUBTEXT,
  fontSize: 13,
  lineHeight: "20px"
};

const statsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))",
  gap: 10,
  marginBottom: 14
};

const statCard = {
  background: CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: 14,
  padding: 14
};

const statLabel = {
  color: SUBTEXT,
  fontSize: 12,
  fontWeight: "800"
};

const statValue = {
  fontSize: 28,
  fontWeight: "900",
  marginTop: 6
};

const emptyCard = {
  background: CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: 14,
  padding: 18,
  textAlign: "center"
};

const emptyTitle = {
  color: TEXT,
  fontSize: 17,
  fontWeight: "900"
};

const emptyText = {
  color: SUBTEXT,
  fontSize: 13,
  marginTop: 8
};

const withdrawalCard = {
  background: CARD,
  border: `1px solid rgba(0,242,255,0.20)`,
  borderRadius: 16,
  padding: 15,
  marginBottom: 13,
  boxShadow: "0 4px 10px rgba(0,0,0,0.35)"
};

const cardTop = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 10,
  marginBottom: 12
};

const cardTitle = {
  color: TEXT,
  fontSize: 16,
  fontWeight: "900"
};

const cardSub = {
  color: SUBTEXT,
  fontSize: 12,
  marginTop: 4,
  wordBreak: "break-all"
};

const statusBadge = {
  border: "1px solid",
  borderRadius: 999,
  padding: "6px 10px",
  fontSize: 11,
  fontWeight: "900",
  textTransform: "uppercase"
};

const infoGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))",
  gap: 10
};

const infoLine = {
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  padding: 11
};

const infoLabel = {
  color: SUBTEXT,
  fontSize: 10,
  fontWeight: "800",
  marginBottom: 5,
  textTransform: "uppercase"
};

const infoValue = {
  color: TEXT,
  fontSize: 13,
  fontWeight: "900",
  wordBreak: "break-all"
};

const actionBox = {
  marginTop: 13,
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  padding: 12
};

const warningText = {
  color: GOLD,
  fontSize: 12,
  lineHeight: "18px",
  marginBottom: 12
};

const buttonsRow = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap"
};

const approveBtn = {
  flex: 1,
  minWidth: 180,
  background: NEON_CYAN,
  border: "none",
  borderRadius: 12,
  padding: 12,
  color: "#020617",
  fontWeight: "900",
  cursor: "pointer"
};

const rejectBtn = {
  flex: 1,
  minWidth: 130,
  background: "rgba(255,77,109,0.12)",
  border: `1px solid rgba(255,77,109,0.35)`,
  borderRadius: 12,
  padding: 12,
  color: RED,
  fontWeight: "900",
  cursor: "pointer"
};

const backBtn = {
  width: "100%",
  marginTop: 8,
  background: "transparent",
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  padding: 14,
  color: TEXT,
  fontWeight: "900",
  cursor: "pointer"
};

export default AdminWithdrawalsWebPage;
